import { useCallback } from 'react';
import { Box, useTheme } from '@material-ui/core';
import { SearchType } from '@setvi/shared/components/intelligence/search/interfaces';
import { SSearchInput } from '@setvi/shared/components';
import { debounce } from 'lodash';
import { Divider, SearchContainer, Wrapper } from '../styled';
import { DrawerHeaderTitle } from '../../../drawer-content/components';
import { HeaderProps } from '../..';

export const SearchHeader = ({
  searchQuery,
  feedback,
  closeSearchMode,
  handleSearch
}: Pick<
  HeaderProps,
  'searchQuery' | 'feedback' | 'closeSearchMode' | 'handleSearch'
>) => {
  const { palette } = useTheme();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleChange = useCallback(
    debounce(
      (value: string) =>
        handleSearch({
          type: SearchType.Regular,
          search: { value }
        }),
      700
    ),
    [handleSearch]
  );

  return (
    <>
      <SearchContainer style={{ backgroundColor: palette.common.white }}>
        <Wrapper>
          <DrawerHeaderTitle
            title="Search Products"
            handleClose={closeSearchMode}
          />
          <Box display="flex" gridGap={8}>
            {feedback}
            {/* {viewModeToggler} */}
          </Box>
        </Wrapper>
        <SSearchInput
          onChange={handleChange}
          defaultValue={searchQuery}
          placeholder="Enter keywords to search..."
          style={{
            width: '100%',
            padding: '8px 12px',
            borderRadius: 99,
            height: 40,
            marginBottom: 4
          }}
        />
      </SearchContainer>
      <Divider />
    </>
  );
};
